<style scoped>
  @import "../card-enrollment/sub-pages/css/card-enrollment.scss";
</style>
<script>

import Click2PayModalComponent from '@/components/shared/click2pay-modal/click2pay-modal.vue'
import { CONSTANT, SDK_ID_VISA } from '@/utils/constant'

export default {
  name: 'GuestProfileInfoSave',
  components: {
    'click-to-pay-modal': Click2PayModalComponent
  },
  props: {
    cardBrand: {
      type: String
    }
  },
  data () {
    return {
      close: true,
      error: '',
      CONSTANT: CONSTANT,
      sdk: this.cardBrand,
      showClick2PayModal: false,
      isVisaCard: false
    }
  },

  computed: {
    profileOptOut: {
      get () {
        return this.$store.getters.profileOptOut
      },
      set (value) {
        if (window.opener && window.opener.childSrcWindow) {
          window.opener.postMessage({ profileOptOut: value })
        }
        this.$store.dispatch('updateProfileOptOut', value)
        this.$emit('input', value)

        if (!value) {
          if (window.opener && window.opener.childSrcWindow) {
            window.opener.postMessage({ rememberMe: value })
          }
          this.$store.dispatch('updateRememberMeConsent', value)
        }
      }
    }
  },
  watch: {
    cardBrand: {
      handler (newValue) {
        this.$store.dispatch('updateRememberMeConsent', false)
        if (newValue === SDK_ID_VISA) {
          this.isVisaCard = true
          this.$store.dispatch('updateProfileOptOut', true)
          this.$emit('input', true)
        } else {
          this.isVisaCard = false
          this.$store.dispatch('updateProfileOptOut', false)
          this.$emit('input', false)
        }
        this.sdk = newValue
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<template>
  <div>
    <click-to-pay-modal
      :show="showClick2PayModal"
      :cardbrand="[cardBrand]"
      :displayokbutton="false"
      @onClose="showClick2PayModal = false" />
    <div class="d-inline">
      <img
        class="src-logo"
        src="@/assets/images/src-networks/src_logo.png"
      >
    </div>
    <div
      class="d-inline"
    >
      <img
        :class="sdk+'-logo'"
        :src="require('@/assets/images/src-networks/' + sdk+'.svg')"
        class="mr-1"
      >
    </div>
    <div class="form-check rm-checkbox text-left mt-2">
      <input
        id="save-info"
        v-model="profileOptOut"
        :class="{ 'checkbox-prevent': isVisaCard}"
        class="form-check-input rm-input"
        type="checkbox">
      <label
        :class="{ 'label-cursor': isVisaCard}"
        class="form-check-label rm-label"
        for="save-inf1o">
        <strong> {{ $t ('label.saveMyInfo') }}<button
          class="btn-clicktopay  link-color"
          @click="showClick2PayModal = true">{{ $t ('label.clickToPay') }}</button>{{ $t ('label.fastCheckout') }}</strong>
      </label>
    </div>
    <div class="mt-2">
      <div
        class="col-full"
        data-test="consent"
        value="true">
        <p
          data-test="legal-footnote"
          class="legal">{{ $t ('description.profileOption') }}</p>
      </div>
    </div>
  </div>
</template>
